import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import throttle from 'lodash/throttle';
import styled from 'styled-components';

// Styled Components
import { SmartContainer, Stack, HorizontalStack } from '../../styles/Containers';
import { StyledChip } from '../../styles/matieralui/Chip';
import { splitAndTrim } from '../../services/Utils';

// Components
import { Autocomplete } from '../Forms/Autocomplete';
import { StyledB, StyledP } from '../../styles/StyledHTML';
import { IconTag } from '../../capturecollab/Icons';
import { Theme } from '../../styles/Theme';

const StyledChipInline = styled(StyledChip)`
    margin-bottom: 1em !important;
`

const StyledTags = styled(SmartContainer)`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    p {
        margin-right: 0.25em;
        margin-bottom: 0.25em;
        border: 1px solid currentColor;
        padding: 0.25em 0.5em;
        border-radius: ${Theme.radius};
        border-radius: ${Theme.radius} !important;
        background: ${Theme.colors.dark} !important;
        color: ${Theme.colors.darkText} !important;
    }
    

`


export const TagEditorWithAutoComplete = ({ label, model, modelId, selector, action, saveAction, formLabel = 'Search', disabled = false, onChange, refresh = false, staticOptions = null }) => {


    // ------------------------------
    // State
    // ------------------------------

    const dispatch = useDispatch();
    const [value, setValue] = useState(null);
    const [options, setOptions] = useState([])


    const data = selector();
    const [activeTags, setActiveTags] = useState([])
    const newTag = ''
    const [tagsLoaded, setTagsLoaded] = useState(false);

    // ------------------------------
    // Effects
    // ------------------------------

    const loadTagsForThisModel = () => {
        const args = {}
        args[model] = modelId;
        args['prefix'] = 'tags';
        dispatch(action(0, null, null, 'all', args))

    }

    // Load Tags for This Item
    useEffect(() => {

        // Load Assigned Tags
        if (data?.tagsArgs && data?.tagsArgs[model] === modelId) {
        } else {
            // Get Everything For this Item
            loadTagsForThisModel();
        }

    }, [modelId])

    useEffect(() => {
        if (refresh === true) loadTagsForThisModel();
    }, [refresh])


    // Set Local
    useEffect(() => {
        if (data?.tags?.rows) setActiveTags(data.tags.rows)
    }, [data.tags])

    // Save Tags
    useEffect(() => {
        if (!tagsLoaded) {
            setTagsLoaded(true);
            return;
        }
        // Save Tag Changes
        if (activeTags !== data?.tags?.rows) saveTags(activeTags, modelId);
    }, [activeTags])



    // Test AutoComplete
    const [searchTags, setSearchTags] = useState([]);
    useEffect(() => {

        if (data?.tageditor?.rows) {

            const formatted = data?.tageditor?.rows.map(u => {
                const f = { ...u };
                return f;
            })

            setOptions(formatted)
        }
        else if (data?.tageditor?.rows?.length <= 0) {
            setOptions(null)
        }
    }, [data?.tageditor?.rows])
    // ------------------------------
    // Methods
    // ------------------------------

    const handleRemoveTag = (tag) => {
        if (!tag) return;
        const tags = activeTags.filter(theTag => tag.name !== theTag.name);
        setActiveTags([...tags])
    }

    const handleAddTag = (tag) => {
        if (!tag) {
            return;
        }
        const exists = activeTags.filter(theTag => tag.name === theTag.name).length;
        if (!exists) setActiveTagsFormat([...activeTags, tag])
    }
    const setActiveTagsFormat = (arr) => {

        // Make Sure There Are No Duplicates
        const storage = []
        const filtered = arr.filter(item => {
            if (!storage.includes(String(item.name).toLowerCase())) {
                storage.push(String(item.name).toLowerCase())
                return item;
            }
            return false;

        })
        setActiveTags(filtered)
    }

    const tagDifference = () => {

        // Works for Polling server
        // if (!options) return [];
        // const tags = options.filter(tag => {
        //     const exists = activeTags.filter(theTag => tag.name === theTag.name).length;
        //     return !exists;
        // })
        // return tags;
        if (!options && !staticOptions) return [];

        // Check Static First
        if (staticOptions) {

            const tags = staticOptions?.filter(tag => {
                const exists = activeTags.filter(theTag => tag.name === theTag.name).length;
                return !exists;
            })

            const stags = options?.filter(tag => {
                const exists = activeTags.filter(theTag => tag.name === theTag.name).length;
                return !exists;
            })
            return [...tags, ...stags]
        }

        // Check Options from Server 2nd
        const tags = options.filter(tag => {
            const exists = activeTags.filter(theTag => tag.name === theTag.name).length;
            return !exists;
        })
        return tags;
    }

    const saveTags = useMemo(() => throttle((tags, modelId) => {
        if (saveAction) dispatch(saveAction(tags, model, modelId))
        if (onChange) onChange(tags);
    }, 2000), [])

    const handleNewTag = (name) => {

        // Object FOund
        if (name?.id) {
            handleAddTag(name);
        }
        // String likely new Tag
        else if (name?.indexOf(',') > -1) {
            const formatted = splitAndTrim(name, ',').map(item => { return { name: item }; })
            setActiveTagsFormat([...activeTags, ...formatted]);
        }
        // Single Value
        else {
            handleAddTag({ name }) // Single Value
        }

    }


    // ------------------------------
    // Render
    // ------------------------------

    const renderTags = (tags) => {
        if (!tags) return (<div></div>)

        if (!disabled) {
            return tags.map(tag => (
                <StyledChipInline key={tag.id} label={tag.name} clickable onDelete={() => handleRemoveTag(tag)} />
            ))
        }

        if (disabled) {
            const str = tags.map(t => t.name).join(', ');
            return (
                <StyledTags flex>


                    {tags.map(t => (
                        <StyledP small>{t.name}</StyledP>

                    ))}
                </StyledTags>
            )
            // return <StyledP light small>{str}</StyledP>
        }
    }

    const onSearch = (searchString) => {
        const args = {}
        args['prefix'] = 'tageditor';

        if (!searchString) return;
        if (!staticOptions) dispatch(action(0, 5, searchString, 'all', args))
        else {
            // Don't poll the server until nothing is found in the static list
            const found = tagDifference();

            const x = found?.filter(i => {
                const name = i?.name.toLowerCase();
                if (name.indexOf(searchString.toLowerCase()) >= 0) return i;
                return false;
            })

            if (x?.length <= 0) {
                dispatch(action(0, 5, searchString, 'all', args))
            }
        }


    }

    return (
        <SmartContainer thinking={data.tagsLoading || data.tageditorLoading || data.replaceTagsLoading}>
            <Stack>
                <StyledP><StyledB>{label}</StyledB></StyledP>

                <HorizontalStack>{renderTags(activeTags)}</HorizontalStack>

                {!disabled && (
                    <Autocomplete
                        label={formLabel}
                        onSearch={onSearch}
                        options={tagDifference()}
                        onChange={handleNewTag}
                        type="text"
                        value={value}
                        noOptionsTextAction={handleNewTag}
                        noOptionsText="Add New"
                        optionLabelKey="name"
                        loading={data?.tageditorLoading}

                    />)}
                {/* <Autocomplete
                        label={formLabel}
                        options={tagDifference()}
                        optionLabelKey="name"
                        onChange={handleAddTag}
                        value={newTag}
                        type="text"
                        noOptionsTextAction={handleNewTag}
                        noOptionsText="Add New"
                    /> */}

            </Stack>
        </SmartContainer>
    )
}